import React, { useEffect, useState } from "react";
import styles from "./SummaryList.module.css";
import { useReactToPrint } from "react-to-print";
import Button from "../components/Button";

function SummaryList() {
  let currentDate = new Date();
  const location = JSON.parse(localStorage.getItem("userLogin")).location;
  const restLocations = JSON.parse(sessionStorage.getItem("locations"));

  const [startDate, setStartDate] = useState(currentDate.toISOString().slice(0, 10));
  const [endDate, setEndDate] = useState(new Date(currentDate.setMonth(currentDate.getMonth() + 1)).toISOString().slice(0, 10));
  const [userLocation, setUserLocation] = useState(location == 0 ? restLocations[0].idLocation : location);
  const [banList, setBanList] = useState([]);

  const componentRef = React.useRef(null);
  const contentRef = React.useRef(null);
  const reactToPrintFn = useReactToPrint({ contentRef });

  useEffect(() => {
    loadSummary(startDate, endDate, userLocation);
  }, [startDate, endDate, userLocation]);

  const handleStartChange = async (e) => {
    await setStartDate(new Date(e.target.value).toISOString().slice(0, 10));
  };
  const handleEndChange = async (e) => {
    await setEndDate(new Date(e.target.value).toISOString().slice(0, 10));
  };

  async function loadSummary(start, end, loc) {
    const res = await fetch(`/api/reports/summary?s=${start}&e=${end}&l=${loc}`);
    const data = await res.json();
    setBanList(data);
  }

  const getTimeValue = (aDate) => {
    if (!aDate) {
      return;
    }
    let theDate = new Date(aDate.slice(0, -1));
    let hours = theDate.getHours();
    let minutes = theDate.getMinutes();

    if (hours != 0) {
      return `${hours > 12 ? hours - 12 : hours}:${minutes < 10 ? "0" + minutes : minutes} ${hours > 12 ? "pm" : "am"}`;
    }
  };

  return (
    <section className={styles.summaryList}>
      <div ref={contentRef}>
        <h2 className={styles.pageTitle}>
          Summary List of Banquets - {restLocations.filter((rest) => rest.idLocation == userLocation)[0].Description}
        </h2>
        <h4 className={styles.pageSubtitle}>
          Events scheduled between {new Date(startDate).toLocaleString("en-US", { month: "long", day: "numeric", year: "numeric" })} and{" "}
          {new Date(endDate).toLocaleString("en-US", { month: "long", day: "numeric", year: "numeric" })}
        </h4>
        <div className={styles.dateSection}>
          <div className={styles.inlineDiv}>
            <label htmlFor="">Select Start Date</label>
            <input type="date" name="startdate" id="startdate" value={startDate} onChange={handleStartChange} />
          </div>
          <div className={styles.inlineDiv}>
            <label htmlFor="">Select End Date</label>
            <input type="date" name="enddate" id="enddate" value={endDate} onChange={handleEndChange} />
          </div>
          {location == 0 && (
            <div className={`${styles.inlineDiv} ${styles.radioButton}`}>
              <label style={{ display: "block" }}>Select Location</label>
              {restLocations.map((loc, index) => {
                return (
                  <div className={styles.radioDiv}>
                    <input
                      type="radio"
                      name="restaurant"
                      id={loc.idLocation}
                      className={styles.radioSelection}
                      value={loc.idLocation}
                      checked={userLocation == loc.idLocation ? true : false}
                      onChange={(e) => setUserLocation(e.target.value)}
                      key={loc.idLocation}
                    />
                    <label htmlFor={loc.idLocation}>{loc.Description}</label>
                  </div>
                );
              })}
            </div>
          )}

          <span>
            <Button children="Print" onClick={reactToPrintFn} type="primary" />
          </span>
        </div>
        <table className={styles.summaryListTable}>
          <thead>
            <tr>
              <th>Date</th>
              <th>Day of Week</th>
              <th>Event Name</th>
              <th>Guest Count</th>
              <th>Arrival Time</th>
              <th>Banquet Room</th>
              <th>Service Type</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {banList.length > 0 ? (
              banList.map((ban) => {
                //console.log(ban);
                let theDate = new Date(ban.BanDate.slice(0, -1));
                return (
                  <tr>
                    <td>{theDate.toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric" })}</td>
                    <td>{theDate.toLocaleString("en-US", { weekday: "long" })}</td>
                    <td>{ban.BanquetName}</td>
                    <td>{ban.BanAttendance}</td>
                    <td>{getTimeValue(ban.BanArrivalTime)}</td>
                    <td>{ban.RoomName}</td>
                    <td>{ban.Description}</td>
                    <td>{ban.StatusID == 1 ? "Tentative" : "Confirmed"}</td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td>No Banquets Scheduled</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export default SummaryList;
